import * as Cesium from 'cesium';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useState } from 'react';
import useViewerStore from '../../store-zustand/viewer';
import useprojectStore from '../../store-zustand/project';
import useSearchStore from '../../store-zustand/searchbar';
import TooltipIconButton from "components/TooltipIconButton";
import { BBOX_CENTROID, getBBOX } from '../MapView/MapUtils';
import { MapModalTypes, MapModalAnnotateStatus } from "constant";
import { BeenhereOutlined, Close, NearMeOutlined, EditOutlined, HistoryOutlined, AddCircleOutline } from "@mui/icons-material";

import weatherImg from "./img/weather.svg";
import "material-icons/iconfont/material-icons.css";
mapboxgl.accessToken = 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g';

const Wrapper = styled.div`
  position: relative;

  img.weather {
    margin-right: 5px;
  }

  button {
    z-index: 3;
    position: absolute;
    top: 152px;
    right: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 6rem;
    height: 6rem;
    border-radius: 100%;
    svg {
      margin: 0;
      font-size: 2.5rem;
    }
  }

  [aria-label="close"] {
    top: 10px;
    right: 10px;
    height: 44px;
    width: 44px;
  }
  
  .mapboxgl-ctrl-attrib.mapboxgl-compact {
    margin: -41px;
  }
`;

const CustomTooltip = (props) => {
  const useStyles = makeStyles((theme) => ({
    tooltip: {
      color: "white",
      fontSize: "12px !important",
      backgroundColor: "#5A5A5A",
      borderRadius: 3,
      fontFamily: 'Roboto',
      padding: '8px 10px'
    }
  }));
  const classes = useStyles();
  return <Tooltip classes={classes} {...props} />;
}

const ActionIcon = {
  [MapModalTypes.SearchResult]: <BeenhereOutlined />,
  [MapModalTypes.ProjectListSelected]: <NearMeOutlined />,
  [MapModalTypes.CurrentProject]: <AddCircleOutline />,
  [MapModalTypes.Line]: <EditOutlined />,
  [MapModalTypes.Area]: <EditOutlined />,
  [MapModalTypes.Marker]: <EditOutlined />,
  [MapModalTypes.Profile]: <EditOutlined />,
  [MapModalTypes.Volumn]: <EditOutlined />,
  [MapModalTypes.Line + MapModalAnnotateStatus.Edit]: <HistoryOutlined />,
  [MapModalTypes.Area + MapModalAnnotateStatus.Edit]: <HistoryOutlined />,
  [MapModalTypes.Marker + MapModalAnnotateStatus.Edit]: <HistoryOutlined />,
  [MapModalTypes.Profile + MapModalAnnotateStatus.Edit]: <HistoryOutlined />,
  [MapModalTypes.Volumn + MapModalAnnotateStatus.Edit]: <HistoryOutlined />,
  [MapModalTypes.Line + MapModalAnnotateStatus.Success]: <EditOutlined />,
  [MapModalTypes.Area + MapModalAnnotateStatus.Success]: <EditOutlined />,
  [MapModalTypes.Marker + MapModalAnnotateStatus.Success]: <EditOutlined />,
  [MapModalTypes.Profile + MapModalAnnotateStatus.Success]: <EditOutlined />,
  [MapModalTypes.Volumn + MapModalAnnotateStatus.Success]: <EditOutlined />,
};

const Preview = (props) => {
  const dispatch = useDispatch();
  const { type, status, onAction, info, closeModal, disabled } = props;
  const [actionTitle, setActionTitle] = useState('');
  const { viewer, Current_Temperature } = useViewerStore();
  const { setselectedCategory, setselectedCategoryPK, setproject_id, AddProject, CheckIfUserExist, setproject_modal_information, gettypedataById, setselectedCategoryColor } = useprojectStore();
  const { setkeywords_response } = useSearchStore();
  const [clickstatut, setclickstatut] = useState(false);

  const ActioncloseModal = () => {
    closeModal();
  }

  useEffect(() => {
    if (disabled == true) {
      setclickstatut(true);
    }
  }, [])

  const weather_button_style = {
    position: 'absolute',
    height: '31px',
    left: '14px',
    top: '14px',
    borderRadius: '3px',
    background: '#E5E5E5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#707173',
    fontFamily: 'Roboto',
    outline: 'none',
    padding: '5px 8px'
  }

  const temperature_text_style = {
    fontFamily: 'Open Sans',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '18px',
    letterSpacing: '0em',
  };

  useEffect(() => {
    if (type !== "" && status === undefined) {
      switch (type) {
        case "SearchResult":
          return setActionTitle("Create Project");
        case "CurrentProject":
          return setActionTitle("Add Site Data");
        case "ProjectListSelected":
          return setActionTitle("Fly to Project");
        default:
          return;
      }
    } else if (type !== "" && status !== "") {
      setActionTitle(status);
    }
  }, [status, type]);

  return (
    <Wrapper>
      <CustomTooltip title="Local Weather" aria-label="local-weather" placement="bottom">
        <button style={weather_button_style} >
          <img src={weatherImg} alt="weather" className="weather" />
          <span style={temperature_text_style}>{`${Current_Temperature}`}°C</span>
        </button>
      </CustomTooltip>
      <TooltipIconButton disabled={clickstatut} onClick={() => { ActioncloseModal() }} title="Close" ariaLabel="close" size={34}>
        <Close />
      </TooltipIconButton>
      <TooltipIconButton disabled={clickstatut} title={actionTitle} ariaLabel={type + (status || "")} size={44} bluebg="true" onClick={async () => {
        if (actionTitle === "Create Project") {
          dispatch({ type: 'TOGGLE_MAP_TOOL', show: true });
          dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: true });
          setkeywords_response('');
          setselectedCategoryColor('#E5E5E5');
          const responseCheck = await CheckIfUserExist();
          const BBOX = getBBOX(viewer);
          const Centroid = BBOX_CENTROID(BBOX[0], BBOX[1], BBOX[2], BBOX[3]);
          let address = info.address;
          if (address == undefined || address == ``) {
            address = info.place_name;
          }
          let country = info.country;
          let region = info.region;
          let place = info.place_name;
          let postal_code = info.postal_code;
          let USERID = localStorage.getItem('access_token');
          let TEMPERATURE = info.temperature;

          const body_obj = {
            'postal_code': postal_code,
            'place': place,
            'region': region,
            'country': country,
            'address': address,
            'Centroid': Centroid,
            'BBOX': BBOX,
            'userID': USERID,
            'TEMPERATURE': TEMPERATURE
          }

          const addproject_response = await AddProject(body_obj);
          if (addproject_response == 'error') {
            alert('An error occured while saving data');
          } else {
            setproject_id(addproject_response)
            setselectedCategoryPK(responseCheck[0].pk);
            setselectedCategory('Uncategorized');
            setselectedCategoryColor(responseCheck[0].fields?.COLOR);
          }
        } else if (actionTitle === "Fly to Project") {
          let projectID = info.projectid;
          let BBOX = info.bbox;
          let TYPEID = info.typeId;
          let location = BBOX.replaceAll("[", "");
          location = location.replaceAll("]", "");
          location = location.replaceAll("'", "");
          location = location.replaceAll(" ", "");
          location = location.split(",");

          viewer.camera.flyTo({ destination: Cesium.Rectangle.fromDegrees(parseFloat(location[0]), parseFloat(location[2]), parseFloat(location[1]), parseFloat(location[3]))});
          setproject_id(projectID);
          setproject_modal_information({
            info: {
              address: info.address,
              place_name: info.place_name,
              postal_code: info.postal_code,
              region: info.region,
              country: info.country,
              description: info.description,
              temperature: info.temperature,
              location: info.location,
              projectname: info.projectname
            }
          });
          
          const typeData = await gettypedataById(TYPEID);
          setselectedCategory(typeData[0].fields.TYPENAME);
          setselectedCategoryPK(typeData[0].pk);
          setselectedCategoryColor(typeData[0].fields.COLOR);
        }
        onAction(actionTitle);
      }}>
        {ActionIcon[type + (status || "")]}
      </TooltipIconButton>
    </Wrapper >
  );
};

export default Preview;
